import { api } from './client';

export interface Produto {
  id: number;
  codigo?: string;
  descricao?: string;
  ean?: string;
  ncm?: string;
  cfop_padrao?: string;       // NAO "cfop"
  ucom?: string;               // NAO "unidade"
  valor_unitario?: number | string;  // NAO "preco"
  csosn?: string;
  cst_icms?: string;
  orig?: string;
  cest?: string;
  vtottrib?: number | string;
  tipo?: 'produto' | 'servico';
  ativo?: boolean;
  origem?: string;
}

export async function listProdutos(): Promise<Produto[]> {
  const { data } = await api.get<Produto[]>('/produtos');
  return data;
}

export async function getProduto(id: number): Promise<Produto> {
  const { data } = await api.get<Produto>(`/produtos/${id}`);
  return data;
}

export async function createProduto(payload: Partial<Produto>): Promise<Produto> {
  const { data } = await api.post<Produto>('/produtos', payload);
  return data;
}

export async function updateProduto(id: number, payload: Partial<Produto>): Promise<Produto> {
  const { data } = await api.put<Produto>(`/produtos/${id}`, payload);
  return data;
}

export async function deactivateProduto(id: number): Promise<void> {
  await api.delete(`/produtos/${id}`);
}

export async function proximoCodigoProduto(): Promise<string> {
  const { data } = await api.get<{ codigo: string }>('/produtos/proximo-codigo');
  return data.codigo;
}
